import { useTranslation } from "react-i18next";
import { useOrderStore } from "../../store/orderStore";

/**
 * Badge showing count of portal orders in "to_validate" (Story 7-7).
 * Shown on Orders nav item for admin/manager. Hidden when 0.
 */
export function OrdersBadge() {
  const { t } = useTranslation("orders");
  const count = useOrderStore((s) => s.toValidatePortalCount);
  if (!count || count === 0) return null;

  return (
    <span
      className="inline-flex min-w-[1.25rem] h-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold bg-primary-600 text-white dark:bg-primary-500"
      aria-label={t("badge_to_validate", { count })}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
